import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { CommonService } from "app/reusable/common.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-delete-mid-office-diagnose',
  templateUrl: './delete-mid-office-diagnose.component.html',
  styleUrls: ['./delete-mid-office-diagnose.component.scss']
})
export class DeleteMidOfficeDiagnoseComponent implements OnInit, OnDestroy {
  dialogOpened = false;
  @Input() modId: any;
  @Output() Change: EventEmitter<{
    modId;
    dialogstatus;
  }> = new EventEmitter();
  private _subject$: Subject<boolean> = new Subject();

  constructor(private CommonService: CommonService) { }

  ngOnInit() {
  }

  public Delete() {
    let deleteUrl: string = `MidOfficeDiagnose/Delete/${this.modId}`;
    this.CommonService.delete(deleteUrl).pipe(takeUntil(this._subject$)).subscribe(
      (res) => {
        this.Change.emit({
          modId: this.modId,
          dialogstatus: this.dialogOpened,
        })
      },
      (err) =>{
        this.Change.emit({
          modId: "",
          dialogstatus: this.dialogOpened,
        })
      });    
  }

  public Cancel() {
    this.Change.emit({
      modId: "",
      dialogstatus: this.dialogOpened,
    });
  }

  ngOnDestroy() {
    this._subject$.unsubscribe();
  }
}